import React, { Component } from "react";
import logger from "../utils/logger.ts";
import ActivityPagination from "../components/ActivityLog/ActivityPagination.component";
import * as api from "api/api";

import ActivityTable from "../components/ActivityLog/ActivityTable.component";
import { connect } from "react-redux";
import { RIGHT_ARROW, CHEVRON_LEFT, OPTION_CLOSE } from "src/constants/images";
import {
  fetchActivityLog,
  clearActivity,
} from "../redux/actions/activityLog.action";
import { fetchICXPricingData } from "../redux/actions/icxPricing";
import SEO from "components/SEO";
import StatsContainer from "../components/MarketPlace/statsContainer/statsContainer";
import { GoInfo } from "react-icons/go";

const pageSize = 20;
export class Activity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactionAnalytics: {},
      transactionFetchIncomplete: true,
      paginationState: {
        currentPage: 1,
        activityCurrentTotalList: this.props.activityLogList,
        parsableList: this.props.activityLogList,
        totalSize: this.props.listTotalSize,
        totalPage: this.props.listTotalPage,
        pageSize: pageSize,
      },
      filterState: {
        isActive: false,
        typeList: {
          activity_type: [
            // "All Types",
            "FOR_SALE",
            "SKILL_UPGRADE",
            "SOLD",
            "NAME_CHANGE",
            "SOLD_ON_CRAFT",
            "STORY_ADDED",
            "TRANSFER",
          ],
        },
        activeFilterList: [],
        filterType: {
          attr: null,
          value: null,
        },
      },
    };
    this.clearCacheData();
    this.getStats();
    const pastPage = window.location.hash.split("#")[1];
    if (pastPage != undefined) {
      logger.debug("Past page parsed", { pastPage: parseInt(pastPage) });
      if (
        parseInt(pastPage) >= 1 &&
        parseInt(pastPage) <= this.props.listTotalPage
      ) {
        this.state.paginationState.currentPage = parseInt(pastPage);
      }
    }
  }

  clearCacheData = async () => {
    await caches.keys().then((names) => {
      logger.debug("Activity names retrieved", { names });
      names.forEach((name) => {
        caches.delete(name);
      });
    });
    return true;
  };

  getStats = async () => {
    const res = await api.getTransactionAnalytics();
    const getTotalTransaction = await api.getTransactionCount();
    this.setState((prev) => {
      return {
        ...prev,
        transactionAnalytics: res.data,
        transactionFetchIncomplete: false,
        totalTx: getTotalTransaction,
      };
    });
  };
  componentDidMount() {
    this.clearCacheData();
    this.props.onClearActivity();
    this.props.onfetchActivityLog();
    this.props.onFetchICXPricing();
    logger.debug("Service worker building");
    this.activityTimer = setInterval(() => {
      logger.debug("Service worker listening");
      this.clearCacheData();
      this.props.onClearActivity();
      this.props.onFetchICXPricing();
      this.props.onfetchActivityLog();
    }, 60000);
  }
  componentWillUnmount() {
    logger.debug("Service worker destroying");
    clearInterval(this.activityTimer);
  }
  componentDidUpdate = async (prev) => {
    logger.debug("Activity log comparison", { 
      prev, 
      currentFirstItem: this.props.activityLogList[0]?.createdAt,
      currentStateItem: this.state.paginationState.activityCurrentTotalList[0]?.createdAt
    });
    this.clearCacheData();
    if (
      this.props.activityLogList[0]?.createdAt !=
      this.state.paginationState.activityCurrentTotalList[0]?.createdAt
    ) {
      await this.setState((prevState) => {
        return {
          ...prevState,
          paginationState: {
            ...prevState.paginationState,
            activityCurrentTotalList: this.props.activityLogList,
          },
        };
      });
      // this.filterBy(
      //   this.props.activityLogList,
      //   this.state.filterState.filterType.attr,
      //   this.state.filterState.filterType.value
      // );
      let filterTypeNameArray = [];
      this.state.filterState.activeFilterList.map((data) => {
        filterTypeNameArray.push(data.name);
      });
      this.filterActiveTypes(
        this.state.filterState.activeFilterList,
        filterTypeNameArray,
        this.props.activityLogList
      );
    }
  };

  nextPage = (currentPage, listTotalPage) => {
    if (currentPage >= 1 && currentPage < listTotalPage) {
      let currentPage1 = currentPage;
      logger.debug("Current page updated", { currentPage: currentPage1 });
      if (navigateState) {
        navigateState(null, null, `#${currentPage1 + 1}`);
      } else {
        location.hash = `#${currentPage1 + 1}`;
      }

      this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
            currentPage: currentPage1 + 1,
          },
        };
      });
    }
  };

  prevPage = (currentPage, listTotalPage) => {
    if (currentPage > 1 && currentPage <= listTotalPage) {
      let currentPage1 = currentPage;
      if (navigateState) {
        navigateState(null, null, `#${currentPage1 - 1}`);
      } else {
        location.hash = `#${currentPage1 - 1}`;
      }
      this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
            currentPage: currentPage1 - 1,
          },
        };
      });
    }
  };

  onPaginationInputChange = (val) => {
    logger.debug("Value validation", { value: val, isNaN: Number.isNaN(parseInt(val)) });
    if (!Number.isNaN(parseInt(val))) {
      if (
        parseInt(val) >= 1 &&
        parseInt(val) <= this.state.paginationState.totalPage
      ) {
        if (navigateState) {
          navigateState(null, null, `#${parseInt(val)}`);
        } else {
          location.hash = `#${parseInt(val)}`;
        }
        this.setState((prev) => {
          return {
            ...prev,
            paginationState: {
              ...prev.paginationState,
              currentPage: parseInt(val),
            },
          };
        });
      }
    }
  };

  _ParseTypeToProperGrammar = (string) => {
    return (
      string.toLowerCase().replaceAll("_", " ").charAt(0).toUpperCase() +
      string.toLowerCase().replaceAll("_", " ").slice(1)
    );
  };
  //single filter function
  filterBy = async (list, attr = null, value = null) => {
    let filteredResult = [];

    if (attr != null && value != null) {
      logger.debug("Filtering activity", { 
        listLength: list.length, 
        hasAttrAndValue: attr != null && value != null,
        filteredResult 
      });
      filteredResult = await list.filter((log) => log[attr] == value);
      logger.debug("Filter result", { filteredResult });
      this.addActiveFilter(
        this._ParseTypeToProperGrammar(value),
        filteredResult.length
      );

      this.onPaginationInputChange(1);
      this.setState((prev) => {
        return {
          ...prev,
          filterState: {
            ...prev.filterState,
            isActive: true,
            filterType: {
              attr: attr,
              value: value,
            },
          },
        };
      });
    } else {
      logger.debug("No filtering applied", { 
        listLength: list.length, 
        hasAttrAndValue: attr != null && value != null 
      });
      filteredResult = list;
      this.setState((prev) => {
        return {
          ...prev,
          filterState: {
            ...prev.filterState,
            isActive: false,
            filterType: {
              attr: attr,
              value: value,
            },
          },
        };
      });
    }
    this.setState((prev) => {
      return {
        ...prev,
        paginationState: {
          ...prev.paginationState,
          parsableList: filteredResult,
          totalSize: filteredResult.length,
          totalPage: Math.ceil(filteredResult.length / pageSize),
        },
      };
    });
  };

  //multiple filter function
  filterActiveTypes = async (activeTypeList, filterTypeNameArray, list) => {
    let filteredResult = [];
    logger.debug("Activity filter types", { activeTypeList, filterTypeNameArray });

    if (activeTypeList.length >= 1) {
      // let filterTypeNameArray = [];
      // activeTypeList.map((data) => {
      //   filterTypeNameArray.push(data.name);
      // });
      let count = {
        FOR_SALE: 0,
        SKILL_UPGRADE: 0,
        SOLD: 0,
        NAME_CHANGE: 0,
        SOLD_ON_CRAFT: 0,
        STORY_ADDED: 0,
        TRANSFER: 0,
      };
      if (
        filterTypeNameArray.includes(
          this._ParseTypeToProperGrammar("SOLD_ON_CRAFT")
        )
      ) {
        logger.debug("Filtering sold on craft");
        filteredResult = await list.filter((log) => {
          if (log?.from_craft) {
            logger.debug("Found craft sale", { fromCraft: log?.from_craft });
            count["SOLD_ON_CRAFT"] += 1;
            return true;
          }
        });
        list = filteredResult;
      }
      logger.debug("Craft filter result", { filteredResult });
      if (
        filterTypeNameArray.includes(
          this._ParseTypeToProperGrammar("FOR_SALE")
        ) ||
        filterTypeNameArray.includes(
          this._ParseTypeToProperGrammar("SKILL_UPGRADE")
        ) ||
        filterTypeNameArray.includes(
          this._ParseTypeToProperGrammar("STORY_ADDED")
        ) ||
        filterTypeNameArray.includes(this._ParseTypeToProperGrammar("SOLD")) ||
        filterTypeNameArray.includes(
          this._ParseTypeToProperGrammar("NAME_CHANGE")
        ) ||
        filterTypeNameArray.includes(this._ParseTypeToProperGrammar("TRANSFER"))
      ) {
        filteredResult = await list.filter((log) => {
          if (
            filterTypeNameArray.includes(
              this._ParseTypeToProperGrammar(log["activity_type"])
            )
          ) {
            count[log["activity_type"]] += 1;
            return true;
          }
        });
      }
      logger.debug("Final filter result", { filteredResult });

      this.onPaginationInputChange(1);
      let addList = [];
      filterTypeNameArray.map(async (data) => {
        addList.push({
          name: data,
          count: count[data.toUpperCase().replaceAll(" ", "_")],
        });
      });
      await this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
          },
          filterState: {
            ...prev.filterState,
            activeFilterList: addList,
          },
        };
      });
      this.setState((prev) => {
        return {
          ...prev,
          filterState: {
            ...prev.filterState,
            isActive: true,
          },
        };
      });
    } else {
      logger.debug("Removing all filters");
      filteredResult = list;
      this.setState((prev) => {
        return {
          ...prev,
          filterState: {
            ...prev.filterState,
            isActive: false,
          },
        };
      });
    }
    this.setState((prev) => {
      return {
        ...prev,
        paginationState: {
          ...prev.paginationState,
          parsableList: filteredResult,
          totalSize: filteredResult.length,
          totalPage: Math.ceil(filteredResult.length / pageSize),
        },
      };
    });
  };

  addActiveFilter = async (type) => {
    let filterTypeNameArray = [];
    await this.state.filterState.activeFilterList.map((data) => {
      filterTypeNameArray.push(data.name);
    });
    logger.debug("Filter type name array", { filterTypeNameArray });
    if (!filterTypeNameArray.includes(type)) {
      let list = this.state.filterState.activeFilterList;
      filterTypeNameArray.push(type);
      list.push({ name: type, count: 0 });
      await this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
          },
          filterState: {
            ...prev.filterState,
            activeFilterList: list,
          },
        };
      });
      this.filterActiveTypes(
        this.state.filterState.activeFilterList,
        filterTypeNameArray,
        this.props.activityLogList
      );
    }
  };

  removeActiveFilter = async (type) => {
    if (type == "ALL") {
      await this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
          },
          filterState: {
            ...prev.filterState,
            activeFilterList: [],
          },
        };
      });
      let filterTypeNameArray = [];
      await this.state.filterState.activeFilterList.map((data) => {
        filterTypeNameArray.push(data.name);
      });
      this.filterActiveTypes(
        this.state.filterState.activeFilterList,
        filterTypeNameArray,
        this.props.activityLogList
      );
    } else if (!this.state.filterState.activeFilterList.includes(type)) {
      let list = this.state.filterState.activeFilterList;
      let removedList = await list.filter((data) => data.name != type);
      await this.setState((prev) => {
        return {
          ...prev,
          paginationState: {
            ...prev.paginationState,
          },
          filterState: {
            ...prev.filterState,
            activeFilterList: removedList,
          },
        };
      });
      let filterTypeNameArray = [];
      await this.state.filterState.activeFilterList.map((data) => {
        filterTypeNameArray.push(data.name);
      });
      this.filterActiveTypes(
        this.state.filterState.activeFilterList,
        filterTypeNameArray,
        this.props.activityLogList
      );
    }
  };
  render() {
    // console.log(this.state);
    let viewAbleLog = this.state.paginationState.parsableList.slice(
      (this.state.paginationState.currentPage - 1) * pageSize,
      pageSize * this.state.paginationState.currentPage
    );
    const Chip = ({ text, count, handleClose }) => {
      return (
        <div className="filter-chip-card">
          <div>
            {text ? text : ""}{" "}
            <span
              style={{ color: "grey", fontSize: "12px", marginLeft: "4px" }}
            >
              ({count ? count : "0"}){" "}
            </span>
          </div>
          {
            <svg
              onClick={() => {
                handleClose(text);
              }}
              xmlns="http://www.w3.org/2000/svg"
              height="18px"
              viewBox="0 0 24 24"
              width="18px"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          }
        </div>
      );
    };
    const pageMetaData = {
      pageTitle: `Activity | GangstaBet: A Digital Collectible  `,
      pageDescription: null,
      pageKeywords: null,
      pageImage: null,
    };
    return (
      <SEO pageMetaData={pageMetaData}>
        <div className="container activity-container">
          <StatsContainer
            transactionAnalytics={this.state.transactionAnalytics}
            isLoading={this.state.transactionFetchIncomplete}
            totalTx={this.state.totalTx}
          />
          <div className="activity-top">
            <div className="activity-left">
              <h2>Activity Log</h2>
              <p>
                This page shows all offers, sales, and purchases. Page will auto
                refresh every 60 seconds.
                <span className="custom-tooltip craft-info-tooltip">
                  <span className="tooltiptext">
                    {" "}
                    Bid buys from Craft are not included in the log yet.
                  </span>
                  <GoInfo />
                </span>
              </p>
            </div>
            <div className="activity-right filter-container">
              {/* <div className="filter-text">Filter</div> */}
              <div
                className="al-filters dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.92 8.17969H11.69H6.07999C5.11999 8.17969 4.63999 9.33969 5.31999 10.0197L10.5 15.1997C11.33 16.0297 12.68 16.0297 13.51 15.1997L15.48 13.2297L18.69 10.0197C19.36 9.33969 18.88 8.17969 17.92 8.17969Z"
                      fill="#DADADA"
                    />
                  </svg>
                }

                <div className="al-filter-selected ">
                  {this.state.filterState.filterType.value == null
                    ? "Types"
                    : this.state.filterState.filterType.value
                        .toLowerCase()
                        .replace("_", " ")
                        .charAt(0)
                        .toUpperCase() +
                      this.state.filterState.filterType.value
                        .toLowerCase()
                        .replace("_", " ")
                        .slice(1)}
                </div>
              </div>

              <ul class="dropdown-menu p-3" aria-labelledby="sortby">
                {this.state.filterState.typeList.activity_type.map(
                  (data, index) => (
                    <li
                      key={index}
                      className="mb-1"
                      onClick={() => {
                        this.addActiveFilter(
                          this._ParseTypeToProperGrammar(data)
                        );
                      }}
                    >
                      <button class="dropdown-item">
                        {data
                          .toLowerCase()
                          .replace("_", " ")
                          .charAt(0)
                          .toUpperCase() +
                          data.toLowerCase().replaceAll("_", " ").slice(1)}
                      </button>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
          <div className="filter-chips">
            {this.state.filterState.activeFilterList.map((data) => (
              <Chip
                text={data.name}
                count={data.count}
                handleClose={this.removeActiveFilter}
              />
            ))}
            {this.state.filterState.activeFilterList.length >= 1 ? (
              <div
                className="clear-all"
                onClick={() => {
                  this.removeActiveFilter("ALL");
                }}
              >
                Clear all
              </div>
            ) : null}{" "}
          </div>

          <div className="al-info">
            {/* <div className="total">
              A Total of{" "}
              <span>
                {" "}
                {this.state.paginationState.parsableList.length} activities
              </span>{" "}
              found
            </div> */}
            <div className="total max">
              Tracks upto last <span>{this.props.maxSize} activities</span>{" "}
            </div>
          </div>

          <div className="card activity-log">
            <ActivityTable
              isLoading={this.props.isLoading}
              activity={viewAbleLog}
              _ParseTypeToProperGrammar={this._ParseTypeToProperGrammar}
              icxRate={this.props.icxRate ? this.props.icxRate : 0}
            ></ActivityTable>
          </div>
          <div className="activity-log-pagination">
            <ActivityPagination
              paginationState={this.state.paginationState}
              listTotalPage={this.state.paginationState.totalPage}
              onPaginationInputChange={this.onPaginationInputChange}
              prevPage={this.prevPage}
              nextPage={this.nextPage}
            />
          </div>
        </div>
      </SEO>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activityLogList: state.activityLog.activityLogList,
    listTotalPage: Math.ceil(
      state.activityLog.activityLogList.length / pageSize
    ),
    listTotalSize: state.activityLog.activityLogList.length,
    maxSize: state.activityLog.maxSize,
    isLoading: state.activityLog.isLoading,
    icxRate: state.icxPricing.price,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onfetchActivityLog: () => dispatch(fetchActivityLog()),
    onFetchICXPricing: () => dispatch(fetchICXPricingData()),
    onClearActivity: () => dispatch(clearActivity()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
